import { useTranslation } from 'react-i18next';

function splitParagraphs(value: string): string[] {
  return value.split(/\n{2,}/);
}

export default function OverseasComparison() {
  const { t } = useTranslation();

  const body = t('coursesMaster.overseas.body');
  const highlight = t('coursesMaster.overseas.highlight');

  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center">
          {String(t('coursesMaster.overseas.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesMaster.overseas.title')}
          </h2>
          <div className="gold-line mx-auto mb-8"></div>
          <div className="border border-background-200/60 bg-background-50 p-8 md:p-10">
            {splitParagraphs(body).map((paragraph, index) => {
              const parts = paragraph.split(highlight);
              return (
                <p
                  key={index}
                  className="text-[16px] text-foreground-700 leading-relaxed tracking-[0.03em] text-left"
                >
                  {parts.length === 2 ? (
                    <>
                      {parts[0]}
                      <span className="font-medium text-foreground-900">{highlight}</span>
                      {parts[1]}
                    </>
                  ) : (
                    paragraph
                  )}
                </p>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
